class BackInStockForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.back-in-stock-form__input');
    this.button = this.querySelector('.back-in-stock-form__submit');
    this.message = this.querySelector('.back-in-stock-form__message');

    this.button.addEventListener('click', this.onSubmit.bind(this));
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit(event);
      }
    });
  }

  connectedCallback() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId !== this.dataset.sectionId) return;

      const variant = event.data.variant;
      if (!variant) return;

      this.dataset.variantId = variant.id;

      const submitButton = event.data.html.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
      const isSoldOut = submitButton?.hasAttribute('disabled') ?? true;

      this.hidden = !isSoldOut;
      if (isSoldOut) this.resetForm();
    });
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
  }

  resetForm() {
    this.input.disabled = false;
    this.input.value = '';
    this.button.disabled = false;
    this.message.hidden = true;
  }

  onSubmit(event) {
    event.preventDefault();

    const email = this.input.value.trim();
    if (!email || !email.includes('@')) {
      this.showMessage(this.dataset.invalidEmailText, true);
      return;
    }

    const variantId = this.dataset.variantId;
    this.button.disabled = true;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + this.dataset.klaviyoCompanyId, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        revision: '2024-10-15',
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId,
              },
            },
          },
        },
      }),
    })
      .then((response) => {
        if (response.ok || response.status === 202) {
          this.showMessage(this.dataset.successText, false);
          this.input.value = '';
          this.input.disabled = true;
        } else {
          this.showMessage(this.dataset.errorText, true);
          this.button.disabled = false;
        }
      })
      .catch(() => {
        this.showMessage(this.dataset.errorText, true);
        this.button.disabled = false;
      });
  }

  showMessage(text, isError) {
    this.message.textContent = text;
    this.message.hidden = false;
    this.message.classList.toggle('back-in-stock-form__message--error', isError);
  }
}

customElements.define('back-in-stock-form', BackInStockForm);
